module.exports = __webpack_public_path__ + "static/media/recycle-junk-cars.39d14483.png";